module.exports = __webpack_public_path__ + "static/media/fdm-example.dd3b3711.png";